import "./question-styles.scss";
export { default as attendance } from "./attendance.json";
export { default as denominations } from "./denominations.json";
export { default as regions } from "./regions.json";

export { default as AttendanceRangeInput } from "./AttendanceRangeInput";
export { default as DenominationInput } from "./DenominationInput";
export { default as GivingRangeInput } from "./GivingRangeInput";
export { default as OneToTenInput } from "./OneToTenInput";
export { default as RegionInput } from "./RegionInput";
export { default as individualQuestions } from "./questions_individual";
export { default as demographQuestions } from "./questions_demograph";
export { default as opinionQuestions } from "./questions_opinion.json";



// WEBPACK FOOTER //
// ./src/assess/question/index.js